import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "custom-tabs-label" }
const _hoisted_2 = { class: "fs-4" }
const _hoisted_3 = { class: "custom-tabs-label" }
const _hoisted_4 = { class: "fs-4" }
const _hoisted_5 = { class: "custom-tabs-label" }
const _hoisted_6 = { class: "fs-4" }

import { ref } from "vue";
import SiderDetail from "@/components/SiderDetail2.vue";
import PaymentService from "../services/PaymentService";
import PaymentServiceInstruction from "../modal/PaymentServiceInstruction.vue";
import PaymentServicePolicy from "../modal/PaymentServicePolicy.vue";
import PaymentServiceInfo from "../modal/PaymentServiceInfo.vue";
import { provide } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentServiceDetail',
  emits: ["update"],
  setup(__props, { expose: __expose, emit: emits }) {

const paymentDetailRef = ref(null);
const detail = ref(Array<any>());
const paymentId = ref();
const isLoading = ref(true);
const activeTab = ref("information");
const detailTitle = ref("");
const sortedServices = ref(Array<any>());

const show = (data, _sortedServices) => {
  detail.value = data;
  detailTitle.value = data.name;
  paymentId.value = data.id;
  sortedServices.value = _sortedServices;

  paymentDetailRef.value?.show();
};



const close = () => {
  paymentDetailRef.value?.hide();
};

provide("paymentDetailRef", paymentDetailRef);
__expose({
  show,
  close,
});

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createBlock(SiderDetail, {
    title: detailTitle.value,
    width: "90%",
    discard: close,
    direction: "ltr",
    ref_key: "paymentDetailRef",
    ref: paymentDetailRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, {
        type: "border-card",
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, { name: "information" }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("action.detail")), 1)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(PaymentServiceInfo, {
                key: paymentId.value,
                "payment-service-id": paymentId.value,
                "close-function": close,
                "sorted-services": sortedServices.value,
                onUpdate: _cache[0] || (_cache[0] = ($event: any) => (emits('update')))
              }, null, 8, ["payment-service-id", "sorted-services"]))
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { name: "instruction" }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("title.instruction")), 1)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(PaymentServiceInstruction, {
                key: paymentId.value,
                "payment-service-id": paymentId.value,
                "close-function": close
              }, null, 8, ["payment-service-id"]))
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, { name: "policy" }, {
            label: _withCtx(() => [
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("title.policy")), 1)
              ])
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(PaymentServicePolicy, {
                key: paymentId.value,
                "payment-service-id": paymentId.value,
                "close-function": close
              }, null, 8, ["payment-service-id"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})